var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeKickTaken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 41.76,
    cy: 8.32,
    r: 3.45,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.83,43.94l-10.56-2.4-1.91-.44a1.14,1.14,0,0,0-1.29,1.6l2.5,5.38a1,1,0,0,0,1.31.48L31.7,39.79A2,2,0,0,0,30.81,36l-14,.37a5.74,5.74,0,0,1-2.35,4.26,5.09,5.09,0,0,1-2.46.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.47,
    y1: 39.68,
    x2: 26.46,
    y2: 42.23,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.14,
    y1: 36.11,
    x2: 27.15,
    y2: 38.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.56,
    y1: 36.26,
    x2: 24.57,
    y2: 38.17,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.05,
    y1: 36.26,
    x2: 22.06,
    y2: 38.16,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.53,
    y1: 36.33,
    x2: 19.54,
    y2: 38.24,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.04,
    y1: 41.52,
    x2: 31.32,
    y2: 39.97,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.68,
    y1: 43.08,
    x2: 27.96,
    y2: 41.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.32,
    y1: 44.64,
    x2: 24.6,
    y2: 43.1,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.06,
    y1: 48.02,
    x2: 17.34,
    y2: 46.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.71,
    y1: 49.59,
    x2: 13.99,
    y2: 48.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.84,
    y1: 41.01,
    x2: 4.7,
    y2: 35.76,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.35,
    y1: 36.97,
    x2: 9.32,
    y2: 30.81,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.49,15.68v3.7a1.08,1.08,0,0,0,1.09,1.08h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20.33 21.38 20.33 23.38 17.71 23.38 17.71 20.23 17.71 19.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33,23.38V29.5A1.31,1.31,0,0,1,19,30.81h0a1.31,1.31,0,0,1-1.31-1.31V23.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20.33 23.38 22.95 23.38 22.95 19.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33,23.38V29.5a1.31,1.31,0,0,0,1.31,1.31h0A1.31,1.31,0,0,0,23,29.5V23.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.14,
    cy: 4.6,
    r: 2.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,10.47a2.92,2.92,0,0,0-2.07-1h-.58a2.15,2.15,0,0,1-1.18.34A2.18,2.18,0,0,1,19,9.45h-.54a2.93,2.93,0,0,0-2.93,2.93v3.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.67,15.68v3.7a1.08,1.08,0,0,1-1.08,1.08h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.67,15.68v-3.3a2.92,2.92,0,0,0-2.92-2.93h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.58,
    y1: 20.46,
    x2: 16.93,
    y2: 20.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.81,15.68v3.7a1.08,1.08,0,0,0,1.08,1.08h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "29.65 21.38 29.65 23.38 27.03 23.38 27.03 20.23 27.03 19.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.65,23.38V29.5a1.31,1.31,0,0,1-1.31,1.31h0A1.31,1.31,0,0,1,27,29.5V23.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "29.65 23.38 32.27 23.38 32.27 19.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.65,23.38V29.5A1.31,1.31,0,0,0,31,30.81h0a1.31,1.31,0,0,0,1.31-1.31V23.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.46,
    cy: 4.6,
    r: 2.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.28,10.47a2.9,2.9,0,0,0-2.06-1h-.59a2.17,2.17,0,0,1-2.35,0h-.55a2.93,2.93,0,0,0-2.92,2.93v3.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,15.68v3.7a1.08,1.08,0,0,1-1.08,1.08h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,15.68v-3.3a2.93,2.93,0,0,0-2.92-2.93h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.89,
    y1: 20.46,
    x2: 26.24,
    y2: 20.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8,26.7q.24-.52.45-1.08A25.88,25.88,0,0,0,42,14.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.12,34.81A25.62,25.62,0,0,0,38,30.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3,16.62a32.12,32.12,0,0,1-.56,5.22A31.4,31.4,0,0,1,44,25",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeKickTaken);
export default __webpack_public_path__ + "static/media/FREE_KICK_TAKEN.82bad2d6b0eeeb1c19de6ed3cfe94c73.svg";
export { ForwardRef as ReactComponent };